import { userService } from '../services/'

export const handleError = (err) => {
    // if(err?.data?.status === 401) {
    //     userService.logout();
    // }
    return {...err?.error, error: err?.error || err?.data, code: err?.status || 400}
}